import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import Modal from "../../components/parent/Modal"
import API_ENDPOINTS from "../../utils/apiEndpoints";

const AddressInfo = () => {

    const { id } = useParams();

    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const fileInputPhotoRef = useRef(null);
    const fileInputDocumentsRef = useRef(null);


    const [classes, setClasses] = useState([]);
    const [casteCategory, setCasteCategory] = useState([]);
    const [mediums, setmediums] = useState([]);
    const [languages, setlanguages] = useState([]);
    const [genders, setgenders] = useState([]);
    const [extra_curricular_activities, setextra_curricular_activities] = useState([]);
    const [countries, setcountries] = useState([]);
    const [co_curricular_activities, setco_curricular_activities] = useState([]);
    const [blood_groups, setblood_groups] = useState([]);
    const [boards, setboards] = useState([]);


    const [checkboxes, setCheckboxes] = useState({
        termsChecked: false,
        privacyChecked: false
    });
    const [formData, setFormData] = useState({
        address1: '',
        address2: '',
        city: '',
        taluk: '',
        district: '',
        state: '',
        zipCode: '',
        country_id: '',
        mobile: '',
        mobileWhatsapp: '',
    });
    // const downloadJsonFile = () => {
    //     const dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(formData, null, 2));
    //     const downloadAnchor = document.createElement("a");
    //     downloadAnchor.href = dataStr;
    //     downloadAnchor.download = "formData.json";
    //     document.body.appendChild(downloadAnchor);
    //     downloadAnchor.click();
    //     document.body.removeChild(downloadAnchor);
    // };

    useEffect(() => {
        const dataToSave = {
            fatherName: formData.fatherName
        };
        localStorage.setItem('formData', JSON.stringify(dataToSave));
    }, [formData.fatherName]);


    const updatedPreviewData = {
        "Address Line 1": formData.address1,
        "Address Line 2": formData.address2,
        "City": formData.city,
        "Taluk": formData.taluk,
        "District": formData.district,
        "State": formData.state,
        "Zip Code": formData.zipCode,
        "Country": countries.find(cls => cls.id === Number(formData.country_id))?.country,
        "Mobile Number": formData.mobile,
        "WhatsApp Number": formData.mobileWhatsapp,
    };



    // useEffect(() => {
    //     // Include the Bearer token in the GET request
    //     axios.get('http://127.0.0.1:8000/api/classes', {
    //         headers: { Authorization: `Bearer ${localStorage.getItem('parentToken')}` }
    //     })

    //         .then(response => setClasses(response.data))
    //         .catch(error => console.error('Error fetching classes:', error));
    // }, []);

    const handleChange = (e) => {
        const value = e.target.value.replace(/[^\x00-\x7F]/g, '');
        setFormData({ ...formData, [e.target.name]: value });
    };

    useEffect(() => {
        const token = localStorage.getItem("parentToken");

        if (!token) {
            console.error("No token found in localStorage");
            return;
        }

        fetch(API_ENDPOINTS.DROPDOWN_DATA, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        })
            .then(response => response.json())
            .then(data => {
                setcountries(data.data.countries)
            })
            .catch(error => console.error("Error fetching classes:", error));
    }, []);

    const handleCoCurricularChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            coCurricularWishToJoin: e.target.value, // Only one selection allowed
        }));
    };



    const handleSubmit = (e) => {
        e.preventDefault();
        setShowModal(true); // Open modal to preview data
    };


    // const handleFinalSubmit = async () => {
    //     try {
    //         const formDataObj = new FormData1();
    //         Object.keys(formData).forEach((key) => formDataObj.append(key, formData[key]));

    //         const response = await axios.post("http://127.0.0.1:8000/api/admission", formDataObj, {
    //             headers: { Authorization: `Bearer ${localStorage.getItem("parentToken")}` },
    //         });

    //         alert(response.data.message); // Show success message
    //         navigate("/parent-info");
    //         setShowModal(false); // Close modal
    //     } catch (error) {
    //         console.error("Error submitting form:", error);
    //     }
    // };


    // const handleFinalSubmit = async () => {
    //     navigate("/academic-info");
    //     setFormData({
    //         address1: '',
    //         address2: '',
    //         city: '',
    //         taluk: '',
    //         district: '',
    //         state: '',
    //         zipCode: '',
    //         country_id: '',
    //         mobile: '',
    //         mobileWhatsapp: '',
    //     })

    // //   try {
    // //     const mobile = 1234567899;
    // //     const response = await axios.post("http://127.0.0.1:8000/api/send-otp", { mobile });
    // //     // setOtpSent(true);
    // //     // setError("");
    // //     console.log(response.data.otp);
    // //     console.log(response);

    // // }catch (error) {
    // //         console.error("Error submitting form:", error);
    // //     }
    // };

    const handleFinalSubmit = async () => {
        const token = localStorage.getItem("parentToken");
        if (!token) {
            console.error("Authentication token is missing.");
            return;
        }

        setLoading(true); // Show "Saving..."

        const requestData = {
            student_id: id,
            address1: formData.address1 || '',  // Use formData value or default to empty
            address2: formData.address2 || '',
            city: formData.city || '',
            taluk: formData.taluk || '',
            district: formData.district || '',
            state: formData.state || '',
            zip_code: formData.zipCode || '',
            country_id: Number(formData.country_id) || '',  // Convert to number if needed
            mobile: formData.mobile || '',
            whatsapp_no: formData.mobileWhatsapp || ''
        };

        // console.log(requestData);

        try {
            const response = await fetch(API_ENDPOINTS.ADDRESS_INFO, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify(requestData),
            });

            const result = await response.json();

            if (!response.ok || !result.success) {
                let errorMessage = result.message || "An error occurred.";
                if (result.data) {
                    errorMessage += "\n" + Object.values(result.data).flat().join("\n");
                }
                alert(errorMessage);
            } else {
                // console.log("Success:", result);
                navigate(`/parent-info/${result.data.addressInfo.id}`);
                setShowModal(false); // Close modal on success
                setFormData({
                    address1: '',
                    address2: '',
                    city: '',
                    taluk: '',
                    district: '',
                    state: '',
                    zipCode: '',
                    country_id: '',
                    mobile: '',
                    mobileWhatsapp: '',
                });
            }
        } catch (error) {
            console.error("Network Error:", error);
            alert("Network error. Please try again.");
        } finally {
            setLoading(false); // Stop loading
        }
    };



    return (
        <>
            {/* Preview Modal */}
            <Modal loading={loading} show={showModal} onClose={() => setShowModal(false)} formData={updatedPreviewData} onFinalSubmit={handleFinalSubmit} />


            <div className="w-full min-h-screen flex items-center justify-center bg-gray-50 px-4">
                <div className="w-full max-w-2xl bg-white rounded-lg shadow-md p-6">
                    <h2 className="text-xl font-semibold text-center mb-4">Address Information</h2>
                    <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">



                        {/* -------address--------- */}
                        {/* Address1 (Full Width) */}
                        <div className="sm:col-span-2">
                            <label className="block text-sm font-medium text-gray-600">Address</label>
                            <input
                                type="text"
                                name="address1"
                                placeholder="Street Address 1"
                                value={formData.address1}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* Address2 (Full Width) */}
                        <div className="sm:col-span-2">
                            {/* <label className="block text-sm font-medium text-gray-600">Address</label> */}
                            <input
                                type="text"
                                name="address2"
                                placeholder="Street Address 2"
                                value={formData.address2}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>


                        {/* City */}
                        <div>
                            <input
                                type="text"
                                name="city"
                                placeholder="City"
                                value={formData.city}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* Taluk */}
                        <div>
                            <input
                                type="text"
                                name="taluk"
                                placeholder="Taluk"
                                value={formData.taluk}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* Disctrict */}
                        <div>
                            <input
                                type="text"
                                name="district"
                                placeholder="District"
                                value={formData.district}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* State */}
                        <div>
                            <input
                                type="text"
                                name="state"
                                placeholder="State"
                                value={formData.state}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* zipcode */}
                        <div>
                            <input
                                type="number"
                                name="zipCode"
                                placeholder="Zip Code"
                                value={formData.zipCode}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>

                        {/* country */}
                        <div>
                            <select
                                name="country_id"
                                required
                                placeholder="country"
                                value={formData.country_id}
                                onChange={handleChange}
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            >
                                <option value="">Select Country</option>
                                {countries.map(cls => (
                                    <option key={cls.id} value={cls.id}>{cls.country}</option>
                                ))}

                            </select>
                        </div>
                        {/* ---------address----- */}


                        {/* mobile Number */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Mobile Number</label>
                            <input
                                type="tel"
                                name="mobile"
                                placeholder=""
                                value={formData.mobile}
                                onChange={handleChange}
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                title="Enter a valid 10-digit mobile number starting with 6, 7, 8, or 9"
                                pattern="[6-9][0-9]{9}"
                            />
                        </div>

                        {/* whatsapp Number */}
                        <div>
                            <label className="block text-sm font-medium text-gray-600">Whatsapp Number</label>
                            <input
                                type="tel"
                                name="mobileWhatsapp"
                                placeholder=""
                                value={formData.mobileWhatsapp}
                                onChange={handleChange}
                                required
                                className="mt-1 w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                title="Enter a valid 10-digit mobile number starting with 6, 7, 8, or 9"
                                pattern="[6-9][0-9]{9}"
                            />
                        </div>




                        {/* Submit Button (Full Width) */}
                        <div className="sm:col-span-2">
                            <button
                                type="submit"
                                className="w-full bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
                            >
                                Preview
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default AddressInfo;
